import { startupConfigureSentry } from './configureSentry';
import { startupConfigureHttpUnauth } from './configureHttpUnauth';
import { configureHttpAuth } from './configureHttpAuth';
import { setupCommon } from '../utils/container/setup-common';
import { startupSupportModule } from '../supportTicket/supportWindow';

export function startupConfigureCommonAuth() {
    setupCommon();
    configureHttpAuth();
    startupConfigureSentry();
    startupSupportModule();
}

export function startupConfigureCommonUnauth() {
    setupCommon();
    startupConfigureHttpUnauth();
    startupConfigureSentry();
    startupSupportModule();
}
